export async function getCategoriesIndicator() {
  return new Promise((resolve) => {
    const categories = 30;
    setTimeout(() => {
      resolve(categories);
    }, 1000);
  });
}
